














































































































import { Vue, Component, Watch, Emit, Prop } from 'vue-property-decorator';
import AMSTable from '@/components/AMSTable.vue';
import AMSInputField from '@/components/AMSInputField.vue';
import { AppStore } from '@/store/modules/app';
import request from '@/utils/request';
import { emptyRule, selectListEmptyRule, phoneRule, telRule } from '@/utils/rules';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import AMSDialog from '@/components/AMSDialog.vue';

import { allStaff } from '@/api/staff';
import { customerNoPermissionLevelList, checkPhoneNumberExist } from '@/api/customer';
@Component({
  components: {
    'ams-table': AMSTable,
    'ams-product': AMSProduct,
    'ams-dialog': AMSDialog
  }
})
export default class AMSEditForm extends Vue {
  brandList = [{ id: '', name: '全部' }];
  staffList: Array<any> = [];
  levelList: Array<any> = [];
  date = new Date().toISOString().substr(0, 10);
  signDate = false;
  deliveryAddresses: Array<any> = [{}];
  settlementTypeList: Array<any> = [{ text: '预付款', value: 'PrePayment' }];
  regionApi: string = '/api/System/Region/Tree';
  headers = [
    { text: '收货人', value: 'name', sortable: false, inputField: { maxlength: 20 } },
    {
      text: '省市区',
      value: 'regionId',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSProduct, {
          props: {
            menuVisible: true,
            needSelectLastOne: true,
            needAllItem: false,
            api: this.regionApi,
            value: param.row['region'] ? param.row['region'].id : null
          },
          on: {
            input: (value: any) => {
              this.inputHandler(value, param);
            }
          }
        });
      }
    },
    { text: '详细地址', value: 'address', sortable: false, inputField: { maxlength: 50 } },
    { text: '手机号', value: 'phone', sortable: false, 
      inputField: { maxlength: 16 ,rules:[ emptyRule('手机号') ] }
    },
    {
      text: '设为默认',
      value: 'isDefault',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('v-radio', {
          props: {
            value: param.index
          },
          on: {
            change: (value: any) => {
              this.setDefaultAddress(value);
            }
          }
        });
      }
    },
    {
      text: '操作',
      value: 'actions',
      isActions: { maxlength: 5 },
      sortable: false
    }
  ];
  showDialog = false;
  deleteAddressIndex: number | null = null;
  @Prop() form!: any;
  @Watch('form', { immediate: true, deep: true })
  onFormChange(newValue: any, oldValue: any) {
    if (newValue) {
      if (newValue.deliveryAddresses && newValue.deliveryAddresses.length) {
        this.deliveryAddresses = newValue.deliveryAddresses;
      } else {
        this.deliveryAddresses = [{}];
      }
    }
  }

  rules = {
    name: [emptyRule('客户名')],
    phone: [emptyRule('手机号'), telRule()],
    sales: [selectListEmptyRule('销售'), (value: any) => (value && value.length <= 3) || '销售不能超过3个'],
    beautyAdvisors: [selectListEmptyRule('美导'), (value: any) => (value && value.length <= 3) || '美导不能超过3个'],
    contactPhone: [phoneRule()],
    address: this.form.regionId ? [emptyRule('详细地址')] : []
  };

  get computedId() {
    return this.form.id ? this.form.id : null;
  }
  get initDefaultAddress() {
    let defaultIndex = null;
    this.deliveryAddresses &&
      this.deliveryAddresses.forEach((a: any, idx: number) => {
        if (a.isDefault) {
          defaultIndex = idx;
        }
      });
    return defaultIndex;
  }

  created() {
    this.getStaff();
    this.getCustomerLevel();
  }

  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
    });
  }
  getCustomerLevel() {
    customerNoPermissionLevelList().then((data: any) => {
      this.levelList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      this.form.levelId = this.form.levelId
        ? this.form.levelId
        : this.levelList.filter((f: any) => {
            return f.isStatic;
          })[0].value;
    });
  }
  checkPhone(phone: any) {
    checkPhoneNumberExist({ phone: phone, ignoreId: this.form.id }).then((data: any) => {
      if (data) {
        AppStore.ShowError('手机号已重复');
      }
      this.$emit('phoneValid', !data);
    });
  }
  inputHandler(value: any, param: any) {
    this.deliveryAddresses[param.index][param.keyName] = value //? value : this.form.deliveryAddresses ? this.form.deliveryAddresses[param.index].regionId : null;
    this.$emit('addressChange', this.deliveryAddresses);
  }
  textChange(value: any) {
    this.deliveryAddresses = value;
    this.$emit('addressChange', this.deliveryAddresses);
  }
  setDefaultAddress(index: number) {
    this.deliveryAddresses.forEach((a: any, idx: number) => {
      a.isDefault = index == idx;
    });
  }
  add(index: number) {
    this.deliveryAddresses.splice(index + 1, 0, { isDefault: false });
  }
  remove(index: number) {
    this.deleteAddressIndex = index;
    this.showDialog = true;
  }

  sure() {
    this.deliveryAddresses.splice(this.deleteAddressIndex!, 1);
    if (this.deliveryAddresses.length < 1) {
      this.deliveryAddresses.push({});
    }
    this.deleteAddressIndex = null;
    this.showDialog = false;
  }
  cancel() {
    this.deleteAddressIndex = null;
    this.showDialog = false;
  }
}
